module.exports = __webpack_public_path__ + "static/img/13.f3fa5bc.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/content-management/13.jpeg
// module id = F/gY
// module chunks = 3